<div
  *ngIf="viewer"
  class="image_viewer"
  [ngClass]="{ image_viewer_show: viewer.show }"
>
  <div class="image_viewer_controller">
    <div class="controllers_parent">
      <div
        class="image_control"
        title="Zoom Out"
        (click)="viewer.width = viewer.width - 10"
      >
        <i class="fa fa-search-minus" aria-hidden="true"></i>
      </div>
      <div
        class="image_control"
        title="Zoom In"
        (click)="viewer.width = viewer.width + 10"
      >
        <i class="fa fa-search-plus" aria-hidden="true"></i>
      </div>
      <div
        class="image_control"
        title="Download"
        (click)="downloadAttachment(viewer)"
      >
        <i class="fa fa-download" aria-hidden="true"></i>
      </div>
      <div class="image_control" title="Close" (click)="hideImage()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </div>
    </div>
  </div>
  <div class="image_viewer_name">
    {{ viewer.file_name }}
  </div>
  <div class="file_name_position">
    <div class="image_viewer_container">
      <div class="file_name_textalign">
        <img
          class="image_link file_name_transition"
          [ngStyle]="{ width: viewer.width + '%' }"
          [src]="viewer.src"
          alt="Loading..."
        />
      </div>
    </div>
  </div>
</div>

<div class="support-dashboard-detail-container">
  <div class="card mt-20 support_type_border">
    <h5 class="card-header">
      <button class="btn btn-light" (click)="goBack()">< Back</button>
      <span>Ticket - {{ ticket.issue_key }}</span>
    </h5>
    <div class="card-body">
      <div class="support_filter justify_flex_end">
        <div class="support_select">
          <div class="support_header">Action</div>
          <div class="support_types_container">
            <div>
              <button class="btn blue_button_small" (click)="loadCorrespondence()">
                Refresh
              </button>
              <button class="btn blue_button_small" (click)="replyTicket()">
                Reply
              </button>
              <button
                class="btn blue_button_small"
                (click)="addToKB()"
                *ngIf="urlPrefix == 'admin'"
              >
                Add To KB
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-20 support_type_border">
        <h5 class="card-header">
          <span>Case Details</span>
        </h5>
        <div class="card-body">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-8">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <b>Subject</b>
                        <p id="eventname">
                          {{ ticket.summary }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <b>Status</b>
                        <p id="eventid">
                          {{ ticket.status }}
                          <span
                            *ngIf="correspondence.length > 0"
                            (click)="ticket['timeline'] = ticket['timeline'] ? false : true"
                            class="nav-link"
                          >
                            <i class="fa fa-history"></i>
                            {{ ticket["timeline"] ? "Hide history" : "History" }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <b>Ticket ID</b>
                        <p id="readonly">
                          {{ ticket.issue_key }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <b>Priority</b>
                        <p id="eventsource">
                          {{ ticket.priority || "-" }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <b>Creator</b>
                        <p id="aws_access_key">
                          {{ ticket.creator || "-" }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <b>Created On</b>
                        <p id="aws_region">
                          {{ ticket.created || "-" }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <b>Issue Type</b>
                        <p id="eventtime">
                          {{ ticket.issue_type || "-" }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <b>Reporter</b>
                        <p id="eventtime">
                          {{ ticket.reporter || "-" }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <b>Assignee</b>
                        <p id="username">{{ ticket.assignee || "NA" }}</p>
                      </div>
                      <div class="col-md-6">
                        <b>Participants</b>
                        <p id="eventtime">
                          {{ participants || "NA" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div>
                    <div>
                      <b>Closed On</b>
                      <p id="eventtime">
                        <span *ngIf="ticket.resolved">
                          {{ ticket.resolved_time || "-" }}
                        </span>
                        <span *ngIf="!ticket.resolved" class="flex-start">
                          <span>
                            <i class="fa fa-clock"></i>
                          </span>
                          <span>
                            {{ ticket["status"] }}
                          </span>
                        </span>
                      </p>
                    </div>
                    <div>
                      <b>Expected Time as per SLA</b>
                      <p id="eventname">
                        {{ ticket?.resolution_sla?.total_time_str || "-" }}
                      </p>
                    </div>
                    <div>
                      <b>Actual Time as per SLA (Resolution Time)</b>
                      <p id="eventname" class="flex-start">
                        <span>
                          {{ ticket?.resolution_sla?.time_completed_str || "-" }}
                        </span>
                        <span
                          class="flex-start grey_fancy"
                          *ngIf="!ticket.resolved && ticket?.resolution_sla?.breached == false"
                        >
                          <i class="fa fa-clock"></i>
                          <span>Within SLA</span>
                        </span>
                        <span
                          class="flex-start green_fancy"
                          *ngIf="ticket.resolved && ticket?.resolution_sla?.breached == false"
                        >
                          <i class="fa fa-check-circle"></i>
                          <span>Within SLA</span>
                        </span>
                        <span
                          class="flex-start red_fancy"
                          *ngIf="ticket?.resolution_sla?.breached"
                        >
                          <i class="fa fa-times-circle"></i>
                          <span>
                            SLA Breached by
                            <strong>{{ ticket?.resolution_sla?.breached_by_str }}</strong>
                          </span>
                        </span>
                      </p>
                    </div>
                    <div>
                      <b>Remaining Time</b>
                      <p id="eventname">
                        {{ ticket?.resolution_sla?.time_remaining_str || "-" }}
                      </p>
                    </div>
                    <div>
                      <b>Breached</b>
                      <p id="eventname">
                        {{ ticket?.resolution_sla?.breached ? "Yes" : "No" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <h5 class="card-header">
          <span>Correspondence</span>
        </h5>
        <div class="card-body">
          <table class="table table-docs table-hover">
            <thead>
              <tr>
                <th *ngFor="let h of correspondenceHeader">{{ h.name }}</th>
              </tr>
            </thead>

            <tbody [ngStyle]="{ display: correspondence.length > 0 ? 'table-row-group' : 'none' }">
              <tr *ngFor="let i of correspondence">
                <td *ngFor="let h of correspondenceHeader">
                  <span [innerHTML]="i[h.id]"></span>
                  <div
                    class="comment_attachments"
                    *ngIf="h.id == 'body' && i.attachments"
                  >
                    <div
                      class="comment_attachment"
                      [title]="attachment.file_name"
                      (click)="!attachment.src ? downloadAttachment(attachment) : viewImage(attachment)"
                      *ngFor="let attachment of i.attachments"
                    >
                      <div class="min_width_150">
                        <span
                          *ngIf="!attachment.src || attachment.src == 'LOADING'"
                          class="padding_10"
                        >
                          <i class="fa fa-file-text font_size_70" aria-hidden="true"></i>
                        </span>
                        <span
                          *ngIf="attachment.src && attachment.src != 'LOADING'"
                          class="min_height_120"
                        >
                          <img [src]="attachment.src" />
                        </span>
                      </div>
                      <div class="attachment_meta">
                        <div class="attachment_text">
                          {{ attachment.file_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody [ngStyle]="{ display: correspondence.length == 0 ? 'table-row-group' : 'none' }">
              <tr>
                <td [attr.colspan]="correspondenceHeader.length">
                  <div class="file_name_textalign">No Correspondence Found</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ticket-timeline
  *ngIf="ticket && ticket['timeline']"
  [comments]="correspondence"
  [status_history]="status_history"
  [ticket]="ticket"
  [resolved]="ticket['resolved']"
  (hideModel)="ticket['timeline'] = null"
></ticket-timeline>

<reply-ticket
  *ngIf="replyTicket_"
  [modalTitle]="modalTitle"
  [ticket]="replyTicket_"
  [supportType]="'minfy'"
  (hideModal)="hideModal($event)"
></reply-ticket>

<add-kb-element
  *ngIf="addKB"
  [supportType]="'minfy'"
  [ticket]="addKB"
  (hideModal)="hideAddKB()"
></add-kb-element>
